import React from 'react';
import styles from './Content.module.scss';
import { DlsFontVariants, DlsColorTokens } from '@/constants/DLSTokens';
import { GenericAvatar } from '@/widgets/GenericAvatar';
import { Text } from '@swiggy-private/dls-web-core/dist/components/Text';
const Content = ({ accounts, handleSelect, selectedAccountName, }) => {
    return (React.createElement("div", { className: styles.container },
        React.createElement("ul", { className: styles.accountList }, accounts.map((account) => {
            return (React.createElement("li", { className: styles.account, key: account.accountId, onClick: () => handleSelect(account) },
                React.createElement(GenericAvatar, { name: account.name, className: styles.accountAvatar }),
                React.createElement("div", { className: styles.accountDetails },
                    React.createElement(Text, { variant: DlsFontVariants.header_H5_Bold, color: DlsColorTokens.text_Highest_Emphasis, className: styles.accountName }, account.name)),
                selectedAccountName === account.name ? (React.createElement(Text, { variant: DlsFontVariants.body_B1_Reg, color: DlsColorTokens.positive }, "Currently Logged-in")) : null));
        }))));
};
export default Content;
